<template>
	<div style="position:relative" class="insert-button-outer">
		<template v-if="PositionFirst">	
			<div style="height:20px"></div>
			<div class="button-text-top insert-button-text" v-on:click="InsertMemberTop">
				<span>ここへ挿入</span>
			</div>
			<div v-if="PositionFirst"
				class="insert-button insert-position-top" 
			>
				<v-btn  v-on:click="InsertMemberTop"></v-btn>
			</div>

		</template>
		<template v-else>
			<div class="button-text-bottom insert-button-text" v-on:click="InsertMemberAfter">
				<span >ここへ挿入</span>
			</div>
			<div 
				class="insert-button insert-position-bottom"
			>
				<v-btn v-on:click="InsertMemberAfter"></v-btn>
			</div>
		</template>
	</div>
</template>
<script>
import MouseStateMachine from '../classes/MouseStateMachine';
import MouseState from '../classes/MouseState';
export default {
	name: 'GBMemberListRowInsertPosition',
	props: [
		"item",
		"isEditable",
		"watchSlide",
		"isSelected",
		"PositionFirst",
	],
	data: function() {
		const state_nop = new MouseState({});
		return {
			state_nop: state_nop,
			sm_insert_btn: new MouseStateMachine(state_nop),
		};
	},
	methods: {
		InsertMemberTop: function(){
			this.$emit('insert-member-row-top',this.item);
		},
		InsertMemberAfter: function(){
			this.$emit('insert-member-row',this.item);
		},
		defaultStateRow: function() {
			if ( !this.isEditable){
				return this.state_nop;
			}
			const state_default = new MouseState({
				down:() =>{
				},
				longpress: () => {
				},
			});
			return state_default
		},
	},
	watch: {
		isEditable: function() {
			this.sm_insert_btn.next(this.defaultStateRow());
		},
	},
	mounted: function() {
		this.sm_insert_btn.next(this.defaultStateRow());
	},
};
</script>
<style>

	.insert-button{
		position: absolute;
		bottom: -20px;
		left: -15px;
	}
	.insert-button:hover{
		bottom: -20px;
	}
	.insert-button .v-btn{
		background-color: #0abb28 !important;
		z-index : 2;
		border-radius: 50%;
		height: 40px !important;
		width: 40px !important;
		min-width:0px;
		padding: 0;
		margin: 0;
		opacity: .5;
	}
	.insert-button .v-btn:hover{
		border-radius: 3%;
		width: 150px !important;
		height: 40px !important;
	}
	.insert-button-outer > .button-text-bottom{
		position: absolute;
		z-index: 2;
		top: -.75rem;
		left: 1.75rem;
	}
	.insert-button-outer > .button-text-top{
		position: absolute;
		z-index: 2;
		bottom: -.75rem;
		left: 1.75rem;
	}
	.insert-button-text{
		color: #0abb28;
		opacity: .5;
		cursor:pointer;
		font-weight: bold;
	}
	.insert-button-text:hover{
		color: #0abb28 !important;
		opacity: .5 !important;
	}
	.insert-button-outer:hover > .insert-button-text,.insert-button-outer:hover > .insert-button-text{
		color:white;
		z-index:3;
		opacity: 1;
	}
	

	

</style>
